import { FC, useState } from 'react';
import * as Tabs from '@radix-ui/react-tabs';
import { useTranslations } from 'next-intl';
import { useSelector } from 'react-redux';
import { IToken } from '@interface/token';
import { RootState } from '@state/store';
import { Collectors } from './collectors';
import { History } from './history';
import { Info } from './info';
import { Market } from './market';
import * as Styles from './styles';

interface IItemTabs {
  token: IToken;
}

export const ItemTabs: FC<IItemTabs> = ({ token }) => {
  const t = useTranslations('token');
  const { holders, swaps, auctions, offers } = useSelector((state: RootState) => state.token);

  // market total
  const total = swaps.length + auctions.length + offers.length;

  const data = [
    {
      key: 'info',
      label: t('info'),
      count: 0,
      Component: Info,
    },
    {
      key: 'collectors',
      label: t('collectors'),
      count: holders.length,
      Component: Collectors,
    },
    {
      key: 'history',
      label: t('history'),
      count: 0,
      Component: History,
    },
    {
      key: 'market',
      label: t('market'),
      count: total,
      Component: Market,
    },
  ];

  const [focused, setFocused] = useState<string>(data[0].key);

  const handleTabFocus = (focusId: string) => {
    setFocused(focusId);
  };

  return (
    <Styles.Container>
      <Tabs.Root asChild defaultValue={focused} onValueChange={handleTabFocus}>
        <Styles.Tabs>
          <Tabs.List asChild aria-label="tabs item">
            <Styles.List>
              {data.map((item) => {
                return (
                  <Tabs.Trigger key={item.key} asChild value={item.key as string}>
                    <Styles.Trigger>
                      {item.label} {item.count > 0 && <Styles.Quantity>{item.count}</Styles.Quantity>}
                    </Styles.Trigger>
                  </Tabs.Trigger>
                );
              })}
            </Styles.List>
          </Tabs.List>

          {data.map((item) => {
            return (
              <Tabs.Content key={item.key} asChild value={item.key}>
                <Styles.Content>{focused === item.key && <item.Component token={token} />}</Styles.Content>
              </Tabs.Content>
            );
          })}
        </Styles.Tabs>
      </Tabs.Root>
    </Styles.Container>
  );
};
